export enum PATHS {
  HOME = '/',
  CONTACT = '/About&Contact',
  BLOG = "/Blog",
  PRESENTATION = "/Presentation",
  DOCS = "/Docs"
}
